const trimWhitespace = input => input.trim();
const trimAllSpaces = input => input?.replace(/ /g, '');
export { trimAllSpaces, trimWhitespace };